import withDebounce from '../utils/WithDebounce';
import SliderElement, {SliderProps} from './Slider';

const DebouncedSlider = withDebounce<SliderProps, number | undefined>(SliderElement, 400);

export default DebouncedSlider;
